"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

exports.EuStars = function (props) {
  return react_1.default.createElement("svg", __assign({}, props, {
    viewBox: "0 0 540 540",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    version: "1.1",
    width: 20,
    height: 20
  }), react_1.default.createElement("desc", null, "European flag"), react_1.default.createElement("defs", null, react_1.default.createElement("g", {
    id: "d"
  }, react_1.default.createElement("g", {
    id: "b"
  }, react_1.default.createElement("path", {
    id: "a",
    d: "M0 0v1h.5z",
    transform: "translate(0,-1)rotate(18)"
  }), react_1.default.createElement("use", {
    xlinkHref: "#a",
    transform: "scale(-1,1)"
  })), react_1.default.createElement("g", {
    id: "c"
  }, react_1.default.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(72)"
  }), react_1.default.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(144)"
  })), react_1.default.createElement("use", {
    xlinkHref: "#c",
    transform: "scale(-1,1)"
  }))), react_1.default.createElement("g", {
    fill: "#fc0",
    transform: "scale(30)translate(9,9)"
  }, react_1.default.createElement("use", {
    xlinkHref: "#d",
    y: -6
  }), react_1.default.createElement("use", {
    xlinkHref: "#d",
    y: 6
  }), react_1.default.createElement("g", {
    id: "e"
  }, react_1.default.createElement("use", {
    xlinkHref: "#d",
    x: -6
  }), react_1.default.createElement("use", {
    xlinkHref: "#d",
    transform: "rotate(150)translate(0,6)rotate(66)"
  }), react_1.default.createElement("use", {
    xlinkHref: "#d",
    transform: "rotate(120)translate(0,6)rotate(24)"
  }), react_1.default.createElement("use", {
    xlinkHref: "#d",
    transform: "rotate(60)translate(0,6)rotate(12)"
  }), react_1.default.createElement("use", {
    xlinkHref: "#d",
    transform: "rotate(30)translate(0,6)rotate(42)"
  })), react_1.default.createElement("use", {
    xlinkHref: "#e",
    transform: "scale(-1,1)"
  })));
};